(function () {
  'use strict';

  /**
   * @param {Element} element
   */
  function checkForShadowRoot(element) {
    const shadow = element.shadowRoot ?? element.attachShadow({ mode: 'open' });

    const existingStyles = shadow.querySelector('style[data-shadowroot-observer]');
    if (existingStyles) {
      return true;
    }

    const styleEl = document.createElement('style');
    styleEl.setAttribute('data-shadowroot-observer', 'true');
    styleEl.textContent = `
      sc-comparison-table sc-product {
        max-width: 386px !important;
        width: 100%;
        margin: 0 auto;
        min-height: unset !important;
      }

      sc-comparison-table sc-product div.relative {
        margin: 0 auto;
      }

      .comparison-table .row-group--body+.row-group--body {
        margin-top: 0;
      }

      sc-comparison-table .comparison-table .column-header:first-child {
        max-width: 248px;
      }

      sc-comparison-table sc-product div.relative {
        background-image: url('https://shopify-dev.swansonvitamins.com/cdn/shop/t/19/assets/image-placeholder.png?v=169700445109464817361757416143');
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        width: 100%;
        height: 100%;
      }

      .row--product:not(:has(.product__image-wrapper)) sc-product div.relative {
        min-height: 250px;
      }

      sc-comparison-table sc-product div.relative::-webkit-scrollbar {
        -webkit-appearance: none !important;
        width: 7px !important;
      }

      sc-comparison-table sc-product div.relative:has(.product__image-wrapper) {
        height: auto;
        background-color: transparent;
        background-image: none;
        min-height: unset;
      }

      /* ============================================================
         IngraiN Label Styling (Preview Match) - Unified Stylesheet
         Wrapper must include one type class:
           - .sf-label.sf-supplement  (Supplement Facts)
           - .sf-label.sf-nutrition   (Nutrition Facts)
           - .sf-label.sf-drug        (Drug Facts)
           - .sf-label.sf-product     (Product Facts)
         Includes compatibility for common export quirks:
           - .sf-indent-1/-2/-3 (maps to preview indent behavior)
           - 2-column exports using .sf-mg-value inside .sf-item
           - .sf-additional-info .sf-field-label
         ============================================================ */

      /* Safety */
      sc-comparison-table .sf-label,
      sc-comparison-table .sf-label * {
        box-sizing: border-box;
      }
      sc-comparison-table .sf-label .sf-mg-value:empty {
        display: none;
      }

      /* Indent compatibility */
      sc-comparison-table .sf-label .sf-indent,
      sc-comparison-table .sf-label .sf-indent-1 {
        padding-left: 8px;
        font-weight: 400;
      }
      sc-comparison-table .sf-label .sf-indent-2 {
        padding-left: 16px;
        font-weight: 400;
      }
      sc-comparison-table .sf-label .sf-indent-3 {
        padding-left: 24px;
        font-weight: 400;
      }

      /* ============================================================
         SUPPLEMENT FACTS 
         ============================================================ */
      sc-comparison-table .sf-label.sf-supplement tr:has(td.sf-item.sf-indent-2 .sf-mg-value:empty) {
        display: none;
      }

      sc-comparison-table .sf-label.sf-supplement {
        border: 3px solid #000;
        width: 460px;
        max-width: 100%;
        padding: 4px;
        color: #000;
        font-family: Arial, Helvetica, sans-serif;
        background: #fff;
        margin: 20px auto;
      }

      sc-comparison-table .sf-label.sf-supplement .sf-label-title {
        font-size: 18px;
        font-weight: 800;
        margin: 0;
        padding-bottom: 4px;
        border-bottom: 12px solid #000;
      }

      sc-comparison-table .sf-label.sf-supplement .sf-serving,
      sc-comparison-table .sf-label.sf-supplement .sf-serving-container {
        font-size: 12px;
        font-weight: 700;
        margin: 0 0 6px 0;
      }

      sc-comparison-table .sf-label.sf-supplement .sf-serving {
        border-bottom: 6px solid #000;
        padding: 2px 0 4px;
      }

      /* Calories row (if present) */
      sc-comparison-table .sf-label.sf-supplement .sf-calories {
        border-bottom: 12px solid #000;
      }
      sc-comparison-table .sf-label.sf-supplement .sf-calories td {
        padding: 8px 0;
        font-weight: 800;
      }
      sc-comparison-table .sf-label.sf-supplement .sf-calories .sf-item {
        font-size: 28px;
      }
      sc-comparison-table .sf-label.sf-supplement .sf-calories .sf-value {
        font-size: 56px;
        font-weight: 800;
        line-height: 1;
        text-align: right;
      }

      /* Table */
      sc-comparison-table .sf-label.sf-supplement .sf-table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 8px;
        border-top: 0;
      }

      sc-comparison-table .sf-label.sf-supplement .sf-table tbody tr {
        border-top: 1px solid #000;
      }
      sc-comparison-table .sf-label.sf-drug .sf-ingredient-table tbody tr {
        border-top: 1px solid #000;
      }
      sc-comparison-table .sf-label.sf-supplement .sf-table td,
      sc-comparison-table .sf-label.sf-supplement .sf-table th {
        font-size: 10px;
        line-height: 14px;
        padding-bottom: 4px;
        padding-top: 4px;
        vertical-align: top;
      }

      sc-comparison-table .sf-label.sf-supplement .sf-table thead th.sf-head-aps {
        text-align: center;
      }

      sc-comparison-table .sf-label.sf-supplement .sf-table th.sf-head-dv {
        text-align: right;
      }

      /* 3-column layout */
      sc-comparison-table .sf-label.sf-supplement .sf-item {
        width: 60%;
      }
      sc-comparison-table .sf-label.sf-supplement .sf-value {
        width: 20%;
        text-align: right;
      }
      sc-comparison-table .sf-label.sf-supplement .sf-dv {
        width: 20%;
        text-align: right;
        font-weight: 700;
      }

      /* 2-column export compatibility (amount floated inside sf-item) */
      sc-comparison-table .sf-label.sf-supplement .sf-mg-value {
        display: inline;
        float: right;
        font-weight: bold;
      }

      sc-comparison-table .sf-label.sf-supplement .sf-bold {
        font-weight: 800;
      }

      sc-comparison-table .sf-label.sf-supplement .sf-protein-divider {
        border-top: 6px solid #000 !important;
      }

      sc-comparison-table .sf-label.sf-supplement .sf-footnote {
        font-size: 10px;
        line-height: 1.3;
        margin-top: 8px;
        padding-top: 6px;
        border-top: 6px solid #000;
      }
      /* ============================================================
         NUTRITION FACTS 
         ============================================================ */
      /* Hide the entire "Includes … Added Sugars" row when its amount span is empty */
      sc-comparison-table .sf-label.sf-nutrition tr:has(td.sf-item.sf-indent-2 .sf-mg-value:empty) {
        display: none;
      }

      sc-comparison-table .sf-label.sf-nutrition {
        border: 3px solid #000;
        width: 460px;
        max-width: 100%;
        padding: 10px;
        color: #000;
        font-family: Arial, Helvetica, sans-serif;
        background: #fff;
        box-sizing: border-box;
        margin: 20px auto;
      }

      /* Title */
      sc-comparison-table .sf-label.sf-nutrition .sf-label-title {
        font-size: 40px;
        font-weight: 800;
        margin: 0 0 6px 0;
        padding-bottom: 4px;
        border-bottom: 12px solid #000;
      }

      /* Serving info */
      sc-comparison-table .sf-label.sf-nutrition .sf-serving,
      sc-comparison-table .sf-label.sf-nutrition .sf-serving-container {
        font-size: 14px;
        font-weight: 700;
        margin: 0 0 6px 0;
      }

      sc-comparison-table .sf-label.sf-nutrition .sf-serving {
        border-bottom: 6px solid #000;
        padding: 6px 0 8px;
      }

      /* ============================================================
         CALORIES SECTION 
         ============================================================ */

      sc-comparison-table .sf-label.sf-nutrition .sf-calories-section {
        border-top: 0;
        border-bottom: 12px solid #000;
        padding: 6px 0 8px 0;
        margin: 6px 0 8px 0;
      }

      sc-comparison-table .sf-label.sf-nutrition .sf-amount-label {
        font-size: 11px;
        font-weight: 700;
        margin-bottom: 2px;
      }

      sc-comparison-table .sf-label.sf-nutrition .sf-calories-row {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
      }

      sc-comparison-table .sf-label.sf-nutrition .sf-calories-label {
        font-size: 28px;
        font-weight: 800;
      }

      sc-comparison-table .sf-label.sf-nutrition .sf-calories-value {
        font-size: 56px;
        font-weight: 800;
        line-height: 1;
        text-align: right;
      }

      /* ============================================================
         NUTRIENTS TABLE
         ============================================================ */

      sc-comparison-table .sf-label.sf-nutrition .sf-table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 4px;
      }

      sc-comparison-table .sf-label.sf-nutrition .sf-table thead th {
        font-size: 11px;
        font-weight: 700;
        padding-bottom: 4px;
        padding-top: 4px;
        text-align: right;
      }

      sc-comparison-table .sf-label.sf-nutrition .sf-table tbody tr {
        border-top: 1px solid #000;
      }

      sc-comparison-table .sf-label.sf-nutrition .sf-table td {
        font-size: 12px;
        padding-bottom: 4px;
        padding-top: 4px;
        vertical-align: top;
      }

      /* Column widths */
      sc-comparison-table .sf-label.sf-nutrition .sf-item {
        width: 60%;
      }

      sc-comparison-table .sf-label.sf-nutrition .sf-dv {
        width: 20%;
        text-align: right;
        font-weight: 700;
      }

      /* ============================================================
         NUTRITION FACTS - Amount should sit right after nutrient name
         ============================================================ */

      /* If you previously added flex on .sf-item, force it back to normal flow */
      sc-comparison-table .sf-label.sf-nutrition .sf-item {
        display: block !important;
      }

      /* Amount should be inline (no float), with a small gap */
      sc-comparison-table .sf-label.sf-nutrition .sf-mg-value {
        float: none !important;
        display: inline !important;
        margin-left: 6px;
        white-space: nowrap;
        font-weight: normal;
      }

      /* Indentation */
      sc-comparison-table .sf-label.sf-nutrition .sf-indent,
      sc-comparison-table .sf-label.sf-nutrition .sf-indent-1 {
        padding-left: 18px;
      }
      sc-comparison-table .sf-label.sf-nutrition .sf-indent-2 {
        padding-left: 36px;
      }

      /* Bold nutrients */
      sc-comparison-table .sf-label.sf-nutrition strong {
        font-weight: 800;
      }

      /* ============================================================
         FOOTNOTE
         ============================================================ */

      sc-comparison-table .sf-label.sf-nutrition .sf-footnote {
        font-size: 10px;
        line-height: 1.3;
        margin-top: 8px;
        padding-top: 6px;
        border-top: 6px solid #000;
      }

      /* Nutrition: hide "Includes … Added Sugars" row when the amount span is empty */
      sc-comparison-table .sf-label.sf-nutrition td.sf-item.sf-indent-2:has(.sf-mg-value:empty) {
        display: none;
      }

      /* ============================================================
         DRUG FACTS (Preview Match)
         Supports both:
           - <h2 class="sf-label-title">Drug Facts</h2>
           - <div class="sf-drug-title">Drug Facts</div> 
         ============================================================ */
      sc-comparison-table .sf-label.sf-drug {
        border: 2px solid #000;
        width: 460px;
        max-width: 100%;
        padding: 16px;
        color: #000;
        font-family: Arial, Helvetica, sans-serif;
        background: #fff;
        margin: 20px auto;
      }

      /* If using h2.sf-label-title */
      sc-comparison-table .sf-label.sf-drug .sf-label-title {
        font-size: 18px;
        font-weight: bold;
        text-align: left;
        margin: 0 0 8px 0;
        padding-bottom: 8px;
        border-bottom: 2px solid #000;
      }

      /* Drug Facts title – no black bar */
      sc-comparison-table .sf-label.sf-drug .sf-drug-title {
        background: transparent;
        color: #000;
        font-size: 18px;
        font-weight: 800;
        text-align: left;
        margin: 0 0 8px 0;
        padding: 0 0 8px 0;
        border-bottom: 2px solid #000;
      }

      sc-comparison-table .sf-label.sf-drug .sf-section {
        margin-bottom: 16px;
      }

      sc-comparison-table .sf-label.sf-drug .sf-section-title {
        font-size: 14px;
        font-weight: bold;
        margin: 0 0 8px 0;
        border-bottom: 1px solid #000;
        padding-bottom: 4px;
      }

      sc-comparison-table .sf-label.sf-drug .sf-section-content {
        font-size: 11px;
        line-height: 1.4;
        margin: 0;
        white-space: pre-line;
      }

      sc-comparison-table .sf-label.sf-drug .sf-ingredient-table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 8px;
      }

      sc-comparison-table .sf-label.sf-drug .sf-ingredient-table th {
        padding: 4px;
        font-size: 11px;
        text-align: left;
        font-weight: bold;
        background: #fff;
        border-bottom: 1px solid #000;
      }

      sc-comparison-table .sf-label.sf-drug .sf-ingredient-table td {
        padding: 4px;
        font-size: 11px;
        border: none;
        vertical-align: top;
      }

      sc-comparison-table .sf-label.sf-drug .sf-directions-table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 8px;
      }

      sc-comparison-table .sf-label.sf-drug .sf-directions-table td {
        padding: 4px;
        font-size: 11px;
        border-bottom: 1px solid #ddd;
      }

      sc-comparison-table .sf-label.sf-drug .sf-directions-table tr:last-child td {
        border-bottom: none;
      }

      /* Optional helper classes seen in some exports */
      sc-comparison-table .sf-label.sf-drug .sf-direction-bullet {
        font-size: 11px;
        line-height: 1.4;
        margin: 0 0 6px 0;
        white-space: pre-line;
      }

      sc-comparison-table .sf-label.sf-drug .sf-directions-age-cell {
        width: 45%;
        font-weight: bold;
        padding-right: 8px;
        vertical-align: top;
      }

      sc-comparison-table .sf-label.sf-drug .sf-directions-dose-cell {
        width: 55%;
        vertical-align: top;
      }

      /* ============================================================
         PRODUCT FACTS 
         Supports export structure using .sf-section + .sf-section-label
         ============================================================ */
      sc-comparison-table .sf-label.sf-product {
        border: 2px solid #000;
        width: 460px;
        max-width: 100%;
        padding: 16px;
        color: #000;
        font-family: Arial, Helvetica, sans-serif;
        background: #fff;
        margin: 20px auto;
      }

      sc-comparison-table .sf-label.sf-product .sf-product-name {
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        margin: 0 0 16px 0;
      }

      sc-comparison-table .sf-label.sf-product .sf-product-info {
        font-size: 12px;
        line-height: 1.4;
        margin: 0 0 12px 0;
      }

      sc-comparison-table .sf-label.sf-product .sf-ingredients {
        font-size: 12px;
        line-height: 1.4;
        margin: 0;
        white-space: pre-line;
      }

      sc-comparison-table .sf-label.sf-product .sf-ingredients strong {
        font-weight: bold;
      }

      sc-comparison-table .sf-label.sf-product .sf-section {
        font-size: 12px;
        line-height: 1.4;
        margin: 0 0 12px 0;
        white-space: pre-line;
      }

      sc-comparison-table .sf-label.sf-product .sf-section-label {
        font-weight: bold;
      }
      sc-comparison-table .sf-label.sf-product .sf-section:last-child {
        margin-bottom: 0;
      }

      /* ============================================================
         ADDITIONAL INFO (Outside label box)
         ============================================================ */
      sc-comparison-table .sf-additional-info {
        font-family: Arial, Helvetica, sans-serif;
        font-size: 12px;
        margin-top: 12px;
        max-width: 100%;
        line-height: 1.4;
      }

      sc-comparison-table .sf-additional-info p {
        margin: 8px 0;
        white-space: pre-line;
      }

      sc-comparison-table .sf-additional-info strong {
        font-weight: 800;
      }

      sc-comparison-table .sf-additional-info ul {
        margin: 8px 0;
        padding-left: 16px;
      }

      sc-comparison-table .sf-additional-info li {
        margin: 4px 0;
      }

      /* Export compatibility */
      sc-comparison-table .sf-additional-info .sf-field-label {
        margin: 8px 0;
        white-space: pre-line;
      }

      sc-comparison-table sc-product .button {
        padding: 12px;
        font-size: 14px;
        line-height: 100%;
        font-weight: 500;
        border-radius: 4px;
        background: #2B2B2B;
        color: #fff;
        margin: auto;
        max-width: 174px;
        width: 100%;
      }

      sc-comparison-table .product__image-wrapper {
        max-width: 290px;
        width: 100%;
        margin: 0 auto;
        @media (max-width: 1440px) {
          max-width: 250px;
        }
      }

      sc-comparison-table sc-product .product__info {
        width: 100%;
      }

      sc-comparison-table sc-product .product__title {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        color: currentColor;
        font-weight: 500;
        text-decoration: none;
        margin-inline: auto;
        flex-grow: 1;
        text-align: center;
      }

      sc-comparison-table sc-product .product__price {
        display: inline-block;
        margin: auto;
        font-size: 24px;
        font-weight: 500;
        line-height: 28px;
        color: #121212;
        text-align: center;
      }

      sc-comparison-table sc-product .rating-badge {
        margin: 0 auto;
        margin-block-start: 0 !important;
      }

      sc-comparison-table sc-product .product__price,
      sc-comparison-table sc-product .rating-badge {
        flex-shrink: 0;
      }

      sc-comparison-table sc-product .star-icon {
        width: 18px;
        height: 18px;
        color: #2B2B2B;
      }

      sc-comparison-table .row.row--attribute td.cell .attribute-value ul {
        padding-left: 10px;
      }
      sc-comparison-table .row.row--attribute td.cell .attribute-value ul li::marker {
        font-size: 12px;
      }

      sc-comparison-table sc-product .button:hover {
        background: var(--color-secondary-button-background-hover);
        color: var(--color-secondary-button-text-hover);
        border-color: var(--color-secondary-button-border-hover);
      }

      sc-comparison-table .row.row--group {
        background-color: #F5F7F8;
        padding-top: 8px;
        border-radius: 4px;
      }

      sc-comparison-table .row-group.row-group--body tr:nth-child(2) {
        border-top: 0;
      }

      sc-comparison-table .row-group.row-group--body tr:last-child {
        border-bottom: 0;
      }

      sc-comparison-table .row.row--group .column-group-header {
        padding-left: 12px;
        margin-left: 12px;
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
        width: 100%;
      }
      sc-comparison-table li {
        list-style-position: outside;
      }

      sc-comparison-table li br {
        display: none;
      }

      sc-comparison-table li p {
        margin: 0;
      }

      sc-comparison-table .row-header.sticky-column {
        margin-left: 12px;
        padding-left: 12px;
      }

      sc-comparison-table .cell {
        padding-top: 21px;
        padding-bottom: 21px;
        max-width: 100%;
      }

      sc-comparison-table .cell:has(.sf-label) {
        padding: 5px;
      }

      sc-comparison-table .row-header {
        padding-top: 21px;
        padding-bottom: 21px;
      }

      sc-comparison-table .attribute-name {
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
        align-items: unset;
        gap: 4px;
      }

      sc-comparison-table .attribute-name sc-tooltip {
        height: fit-content;
      }

      sc-comparison-table .attribute-name img {
        object-fit: cover;
        object-position: left;
        height: 16px;
      }

      .compare-dialog {
        overflow: hidden;
      }

      .compare-dialog__content {
        height: calc(100dvh - 132px);
        overflow: auto;
        scrollbar-width: thin;
        scrollbar-gutter: stable;
        padding: 20px 0;
      }

      .table-scroller.is-scrollable {
        max-height: none;
        overflow: visible;
      }

      sc-comparison-table .row--attribute {
        border-color: #E3E8D4;
      }

      sc-comparison-table .row.row--attribute td.cell .attribute-value {
        justify-content: center;
        font-size: 18px;
        font-weight: 400;
        line-height: 28px;
        display: flex;
        max-width: 100%;
        &:has(span.metafield-multi_line_text_field) {
          display: block;
        }
      }

      .boolean-icon {
        color: #008445;
      }

      sc-comparison-table .metafield-multi_line_text_field br {
        display: none;
      }

      sc-comparison-table .sf-label br {
        display: none;
      }
    `;

    shadow.appendChild(styleEl);
    scheduleResponsiveImageSizes(shadow);
    setupResponsiveImageObserver(element, shadow);

    if (element && element.shadowRoot) {
      return true;
    }
    return false;
  }

  /**
   * @param {HTMLImageElement} imageElement
   */
  function setImageSizesFromWidth(imageElement) {
    const wrapper = imageElement.closest('.product__image-wrapper');
    const targetElement = wrapper || imageElement;
    const width = Math.round(targetElement.getBoundingClientRect().width);
    if (!width) {
      return false;
    }

    const sizesValue = `${width}px`;
    if (imageElement.getAttribute('sizes') !== sizesValue) {
      imageElement.setAttribute('sizes', sizesValue);
    }
    return true;
  }

  /**
   * @param {ShadowRoot} shadow
   */
  function updateResponsiveImageSizes(shadow) {
    const responsiveImages = shadow.querySelectorAll('img.product__image');
    responsiveImages.forEach((imageElement) => {
      if (!(imageElement instanceof HTMLImageElement)) {
        return;
      }
      setImageSizesFromWidth(imageElement);
    });
  }

  /**
   * @param {ShadowRoot} shadow
   */
  function scheduleResponsiveImageSizes(shadow) {
    updateResponsiveImageSizes(shadow);
    requestAnimationFrame(() => {
      updateResponsiveImageSizes(shadow);
    });
    setTimeout(() => {
      updateResponsiveImageSizes(shadow);
    }, 150);
  }

  /**
   * @param {Element} element
   * @param {ShadowRoot} shadow
   */
  function setupResponsiveImageObserver(element, shadow) {
    const elementWithObserver =
      /** @type {HTMLElement & { _responsiveImageObserver?: MutationObserver }} */ (element);
    if (elementWithObserver._responsiveImageObserver) {
      return;
    }

    const observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          shouldUpdate = true;
        }
        if (mutation.type === 'attributes') {
          shouldUpdate = true;
        }
      });

      if (shouldUpdate) {
        scheduleResponsiveImageSizes(shadow);
      }
    });

    observer.observe(shadow, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'src', 'srcset', 'sizes'],
    });

    elementWithObserver._responsiveImageObserver = observer;
  }

  /**
   * @param {ShadowRoot} shadow
   */
  function processProductElements(shadow) {
    const productImages = shadow.querySelectorAll('.floating-compare-bar__product img');
    productImages.forEach((imageElement) => {
      if (!(imageElement instanceof HTMLImageElement)) {
        return;
      }
      const src = imageElement.getAttribute('src');
      if (src && !src.includes('cdn.shopify')) {
        imageElement.setAttribute(
          'src',
          'https://shopify-dev.swansonvitamins.com/cdn/shop/t/19/assets/image-placeholder.png?v=169700445109464817361757416143'
        );
      }
      setImageSizesFromWidth(imageElement);
    });
  }

  /**
   * @param {Element} element
   */
  function checkForShadowRootDynamicCompare(element) {
    const shadow = element.shadowRoot ?? element.attachShadow({ mode: 'open' });
    const existingStyles = shadow.querySelector('style[data-shadowroot-observer-dynamic-compare]');
    if (existingStyles) {
      return true;
    }

    processProductElements(shadow);
    scheduleResponsiveImageSizes(shadow);
    setupResponsiveImageObserver(element, shadow);

    const productList = shadow.querySelector('.floating-compare-bar__product-list');
    if (productList) {
      const elementWithObserver =
        /** @type {Element & { _compareBarObserver?: MutationObserver }} */ (element);
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            setTimeout(() => {
              processProductElements(shadow);
            }, 100);
          }
        });
      });

      observer.observe(productList, {
        childList: true,
        subtree: true,
      });

      elementWithObserver._compareBarObserver = observer;
    }

    const styleEl = document.createElement('style');
    styleEl.setAttribute('data-shadowroot-observer-dynamic-compare', 'true');
    styleEl.textContent = `
      sc-floating-compare-bar sc-compare-dialog-open-button {
        @media (min-width: 768px) {
          width: 100%;
        }
      }
      sc-floating-compare-bar .floating-compare-bar__product-title {
        font-size: 14px;
        font-weight: 500;
        line-height: 100%;
        color: #fdfdfd;
        padding-bottom: 2px;
      }

      sc-floating-compare-bar .floating-compare-bar__product-list {
        scrollbar-color: #888 #f1f1f1;
        scrollbar-width: thin;
        -webkit-appearance: none !important;
      }
      
      sc-floating-compare-bar .column-group-header {
        width: 100%;
      }
      sc-floating-compare-bar sc-compare-dialog-open-button button.button {

        border-radius: 4px !important;
        padding: 12px;
        width: 100%;
      }

      sc-floating-compare-bar sc-compare-dialog-open-button button.button:hover {
        color: #008445 !important;
      }

      sc-floating-compare-bar sc-compare-clear-button button {
        font-family: 'Jost', sans-serif !important;
        text-decoration: none !important;
        color: #fdfdfd !important;
        font-size: 14px;
        line-height: 100%;
      }

      sc-floating-compare-bar sc-compare-clear-button button:hover {
        text-decoration: underline !important;
      }
    `;

    shadow.appendChild(styleEl);

    if (element && element.shadowRoot) {
      return true;
    }
    return false;
  }

  function findAndCheckElements() {
    const dialogElements = document.querySelectorAll('sc-dynamic-compare-dialog');
    dialogElements.forEach((element) => {
      checkForShadowRoot(element);
    });

    const compareElements = document.querySelectorAll('sc-dynamic-compare');
    compareElements.forEach((element) => {
      checkForShadowRootDynamicCompare(element);
    });
  }

  function initShadowRootObserver() {
    findAndCheckElements();

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (!(node instanceof Element)) {
              return;
            }

            if (node.tagName === 'SC-DYNAMIC-COMPARE-DIALOG') {
              checkForShadowRoot(node);
            }

            if (node.tagName === 'SC-DYNAMIC-COMPARE') {
              checkForShadowRootDynamicCompare(node);
            }

            const nestedDialogElements = node.querySelectorAll('sc-dynamic-compare-dialog');
            nestedDialogElements.forEach(function (nestedElement) {
              checkForShadowRoot(nestedElement);
            });

            const nestedCompareElements = node.querySelectorAll('sc-dynamic-compare');
            nestedCompareElements.forEach(function (nestedElement) {
              checkForShadowRootDynamicCompare(nestedElement);
            });
          });
        }

        if (mutation.type === 'attributes' && mutation.target instanceof Element) {
          const targetElement = mutation.target;
          if (targetElement.tagName === 'SC-DYNAMIC-COMPARE-DIALOG') {
            setTimeout(() => {
              checkForShadowRoot(targetElement);
            }, 100);
          }

          if (targetElement.tagName === 'SC-DYNAMIC-COMPARE') {
            setTimeout(() => {
              checkForShadowRootDynamicCompare(targetElement);
            }, 100);
          }
        }
      });
    });

    const config = {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['shadowroot', 'shadowrootmode'],
    };

    observer.observe(document.body, config);

    let checkInterval = setInterval(function () {
      const dialogElements = document.querySelectorAll('sc-dynamic-compare-dialog');
      if (dialogElements.length > 0) {
        dialogElements.forEach((element) => {
          checkForShadowRoot(element);
        });
      }

      const compareElements = document.querySelectorAll('sc-dynamic-compare');
      if (compareElements.length > 0) {
        compareElements.forEach((element) => {
          checkForShadowRootDynamicCompare(element);
        });
      }
    }, 2000);

    setTimeout(() => {
      clearInterval(checkInterval);
    }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShadowRootObserver);
  } else {
    initShadowRootObserver();
  }

  window.addEventListener('load', function () {
    setTimeout(findAndCheckElements, 1000);
  });

  /** @type {Window & { ShadowRootObserver?: {
   *   checkForShadowRoot: (element: Element) => boolean,
   *   checkForShadowRootDynamicCompare: (element: Element) => boolean,
   *   findAndCheckElements: () => void,
   *   init: () => void
   * }}} */
  (window).ShadowRootObserver = {
    checkForShadowRoot: checkForShadowRoot,
    checkForShadowRootDynamicCompare: checkForShadowRootDynamicCompare,
    findAndCheckElements: findAndCheckElements,
    init: initShadowRootObserver,
  };
})();
